<template>
  <section class="unit-section" :class="{ 'is-active': isActive }">
    <!-- 배경 -->
    <div class="bg-wrap" :class="{ 'is-visible': isActive }">
      <img :src="bgImg" alt="" class="bg-image" />
      <div class="bg-overlay"></div>
    </div>

    <!-- 중앙 인트로 타이틀: ChangeSection 스타일 (넓게 → 천천히 줄어듦) -->
    <h2 class="intro-title" :class="{ show: introPhase >= 1, hide: introPhase >= 2 }">
      <span class="intro-word" v-for="(letter, i) in 'UNIT PLAN'.split('')" :key="'u'+i"
        :style="{ '--i': i }"
        :class="{ 'is-space': letter === ' ' }"
      >{{ letter }}</span>
    </h2>

    <!-- 좌측: 타이틀 + 탭 -->
    <div class="left-area" :class="{ 'phase2-show': introPhase === 2 }" ref="leftArea">
      <span class="script-title" ref="scriptTitle">Unit Info</span>
      <h2 class="main-title" :class="{ 'title-arrived': introPhase === 2 }">UNIT PLAN</h2>
      <p class="sub-desc">이안 에코포레 김천구미의 <strong>평면</strong>을 확인하세요</p>

      <!-- 타입 탭 -->
      <div class="type-tabs">
        <button
          v-for="(unit, idx) in units"
          :key="idx"
          class="type-tab"
          :class="{ 'is-active': activeUnit === idx }"
          @click="goUnit(idx)"
        >
          {{ unit.label }}
          <span class="tab-bar"></span>
        </button>
      </div>

    </div>

    <!-- 우측: 큰 흰색 원 -->
    <div class="right-area" :class="{ 'phase2-show': introPhase === 2, 'phase2-show--d2': introPhase === 2 }">
      <div class="circle-frame">
        <!-- 타입명 -->
        <div class="circle-header">
          <transition name="fade" mode="out-in">
            <div :key="activeUnit" class="circle-type-info">
              <span class="ct-name">{{ units[activeUnit].label }}</span>
            </div>
          </transition>
        </div>

        <!-- 도면 이미지 -->
        <div class="circle-img-area">
          <transition name="img-swap" mode="out-in">
            <img :key="activeUnit" :src="units[activeUnit].cardImage" alt="" class="plan-img" />
          </transition>
        </div>
      </div>

      <!-- 화살표 버튼 + 회전 텍스트 -->
      <router-link :to="'/type/' + units[activeUnit].type" class="view-btn">
        <div class="view-spin">
          <svg viewBox="0 0 200 200">
            <defs><path id="unitArc" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" fill="none"/></defs>
            <text><textPath href="#unitArc" startOffset="0%">IAAN ECOFORE UNIT PLAN · IAAN ECOFORE UNIT PLAN ·</textPath></text>
          </svg>
        </div>
        <svg class="view-arrow" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
      </router-link>

      <!-- 네비게이션 -->
      <div class="nav-area">
        <span class="nav-count">
          <strong>{{ String(activeUnit + 1).padStart(2, '0') }}</strong>
          <span class="nav-sep">/</span>
          {{ String(units.length).padStart(2, '0') }}
        </span>
        <div class="nav-btns">
          <button class="nav-btn" @click="goUnitDir(-1)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <span class="nav-divider"></span>
          <button class="nav-btn" @click="goUnitDir(1)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>
      </div>
    </div>

    <!-- 하단 버튼 -->
    <div class="bottom-btns" :class="{ 'phase2-show': introPhase === 2, 'phase2-show--d3': introPhase === 2 }" :style="{ left: btnLeft + 'px' }">
      <router-link :to="'/type/' + units[activeUnit].type" class="bottom-btn">평면안내 바로가기</router-link>
      <router-link to="/reservation/register" class="bottom-btn">관심고객 등록하기</router-link>
    </div>
  </section>
</template>

<script>
import unit84 from '@/assets/84 아이소.jpg'
import unit59A from '@/assets/59A 아이소.jpg'
import unit59B from '@/assets/59B 아이소.jpg'
import unitBgImg from '@/assets/UNIT.jpg'

export default {
  name: 'UnitSection',
  props: { isActive: { type: Boolean, default: false } },
  data() {
    return {
      activeUnit: 0,
      isSliding: false,
      autoPlayTimer: null,
      btnLeft: 0,
      bgImg: unitBgImg,
      introPhase: 0,
      introTimers: [],
      units: [
        { type: '59A', label: '59㎡A', cardImage: unit59A },
        { type: '59B', label: '59㎡B', cardImage: unit59B },
        { type: '84', label: '84㎡', cardImage: unit84 }
      ]
    }
  },
  mounted() {
    this.updateBtnLeft()
    window.addEventListener('resize', this.updateBtnLeft)
  },
  watch: {
    isActive(val) {
      if (val) {
        this.startIntro()
      } else {
        this.resetIntro()
        this.stopAutoPlay()
      }
    }
  },
  beforeUnmount() {
    this.stopAutoPlay()
    this.clearIntroTimers()
    window.removeEventListener('resize', this.updateBtnLeft)
  },
  methods: {
    goUnit(idx) {
      if (idx === this.activeUnit || this.isSliding) return
      this.isSliding = true
      this.activeUnit = idx
      this.restartAutoPlay()
      setTimeout(() => { this.isSliding = false }, 500)
    },
    goUnitDir(dir) {
      let next = this.activeUnit + dir
      if (next < 0) next = this.units.length - 1
      if (next >= this.units.length) next = 0
      this.goUnit(next)
    },
    startAutoPlay() {
      this.stopAutoPlay()
      this.autoPlayTimer = setInterval(() => {
        this.activeUnit = (this.activeUnit + 1) % this.units.length
      }, 5000)
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
        this.autoPlayTimer = null
      }
    },
    restartAutoPlay() {
      this.startAutoPlay()
    },
    startIntro() {
      this.clearIntroTimers()
      this.introPhase = 0

      // Phase 1: 중앙 큰 텍스트 표시 (배경 페이드인과 동시)
      const t1 = setTimeout(() => {
        this.introPhase = 1
      }, 200)

      // Phase 2: 텍스트 페이드아웃 + 콘텐츠 표시 (충분히 스며든 후)
      const t2 = setTimeout(() => {
        this.introPhase = 2
        this.startAutoPlay()
      }, 2000)

      this.introTimers = [t1, t2]
    },
    resetIntro() {
      this.clearIntroTimers()
      this.introPhase = 0
    },
    clearIntroTimers() {
      this.introTimers.forEach(t => clearTimeout(t))
      this.introTimers = []
    },
    updateBtnLeft() {
      this.$nextTick(() => {
        if (this.$refs.scriptTitle) {
          this.btnLeft = this.$refs.scriptTitle.getBoundingClientRect().left
        }
      })
    }
  }
}
</script>

<style scoped>
.unit-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #0c1220;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  padding: 0 80px;
}

/* ===== 배경 ===== */
.bg-wrap {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1.2s ease;
}

.bg-wrap.is-visible {
  opacity: 1;
}

.bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.1);
  transition: transform 6s ease-out;
}

.bg-wrap.is-visible .bg-image {
  transform: scale(1);
}

.bg-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
}

/* ===== 인트로 중앙 타이틀 (ChangeSection 스타일) ===== */
.intro-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 50;
  margin: 0;
  pointer-events: none;
  text-align: center;
  white-space: nowrap;
  transition: opacity 1s ease;
}

.intro-title.hide {
  opacity: 0;
  transition: opacity 0.8s ease;
}

.intro-word {
  display: inline-block;
  font-family: var(--font-serif);
  font-size: clamp(64px, 7vw, 120px);
  font-weight: 600;
  color: #fff;
  letter-spacing: 40px;
  opacity: 1;
  transition: letter-spacing 2.5s cubic-bezier(0.22, 1, 0.36, 1);
  transition-delay: 0.3s;
}

.intro-word.is-space {
  width: 32px;
}

.intro-title.show .intro-word {
  letter-spacing: 14px;
}

/* ===== 좌측 ===== */
.left-area {
  position: relative;
  z-index: 10;
  max-width: 520px;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.left-area.phase2-show {
  opacity: 1;
  transform: translateY(0);
}

.script-title {
  display: block;
  font-family: var(--font-script);
  font-size: 84px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: -8px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.left-area.phase2-show .script-title {
  opacity: 1;
  transform: translateY(0);
}

.main-title {
  font-family: var(--font-serif);
  font-size: 68px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 8px;
  margin: 0 0 28px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.main-title.title-arrived {
  opacity: 1;
  transform: translateY(0);
}

.sub-desc {
  font-family: var(--font-pretendard);
  font-size: 17px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 300;
  margin-bottom: 48px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.15s,
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.15s;
}

.left-area.phase2-show .sub-desc {
  opacity: 1;
  transform: translateY(0);
}

.sub-desc strong {
  color: #fff;
  font-weight: 500;
}

/* ===== 타입 탭 ===== */
.type-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 40px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.3s,
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.3s;
}

.left-area.phase2-show .type-tabs {
  opacity: 1;
  transform: translateY(0);
}

.type-tab {
  position: relative;
  padding: 12px 0;
  background: none;
  border: none;
  font-family: var(--font-paperlogy);
  font-size: 18px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.45);
  cursor: pointer;
  transition: color 0.3s ease;
  white-space: nowrap;
  min-width: 68px;
  text-align: center;
}

.type-tab:hover {
  color: rgba(255, 255, 255, 0.75);
}

.type-tab.is-active {
  color: #fff;
  font-weight: 700;
}

.tab-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(255, 255, 255, 0.15);
}

.type-tab.is-active .tab-bar {
  background: #fff;
}

/* 하단 버튼 */
.bottom-btns {
  position: absolute;
  bottom: 0;
  z-index: 10;
  display: flex;
  gap: 24px;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.bottom-btns.phase2-show {
  opacity: 1;
  transform: translateY(0);
}

.bottom-btns.phase2-show.phase2-show--d3 {
  transition-delay: 0.45s;
}

.bottom-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 36px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-bottom: none;
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  border-radius: 10px 10px 0 0;
}

.bottom-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.7);
}

/* ===== 우측: 원형 ===== */
.right-area {
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  opacity: 0;
  transform: scale(0.9);
  transition: all 1.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.right-area.phase2-show {
  opacity: 1;
  transform: scale(1);
}

.right-area.phase2-show.phase2-show--d2 {
  transition-delay: 0.25s;
}

.circle-frame {
  width: 620px;
  height: 620px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding: 56px 48px 40px;
}

.circle-header {
  text-align: center;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.ct-name {
  font-family: var(--font-paperlogy);
  font-size: 48px;
  font-weight: 700;
  color: #1a2744;
  letter-spacing: 1px;
}

.circle-img-area {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plan-img {
  max-width: 90%;
  max-height: 100%;
  object-fit: contain;
}

/* 네비게이션 */
.nav-area {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 24px;
  padding-right: 20px;
}

.nav-count {
  font-family: var(--font-paperlogy);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.25);
}

.nav-count strong {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

.nav-sep {
  margin: 0 6px;
  color: rgba(255, 255, 255, 0.15);
}

.nav-btns {
  display: flex;
  align-items: center;
  gap: 0;
}

.nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.nav-btn:hover {
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
  background: rgba(255, 255, 255, 0.06);
}

.nav-divider {
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, 0.12);
  margin: 0 8px;
}

/* ===== VIEW 버튼 (회전 텍스트) ===== */
.view-btn {
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--ecofore-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #fff;
  z-index: 15;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.view-btn:hover {
  transform: translateY(-50%) scale(1.08);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}

.view-spin {
  position: absolute;
  width: 140px;
  height: 140px;
  animation: viewSpin 15s linear infinite;
}

.view-spin svg { width: 100%; height: 100%; }
.view-spin text {
  fill: #1a2744;
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.view-arrow {
  position: relative;
  z-index: 2;
  transition: transform 0.4s ease;
}

.view-btn:hover .view-arrow {
  transform: rotate(-45deg);
}

@keyframes viewSpin { to { transform: rotate(360deg); } }

/* ===== 트랜지션 ===== */
.fade-enter-active { transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1); }
.fade-leave-active { transition: all 0.25s ease; }
.fade-enter-from { opacity: 0; transform: translateY(10px); }
.fade-leave-to { opacity: 0; transform: translateY(-8px); }

.img-swap-enter-active { transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1); }
.img-swap-leave-active { transition: all 0.3s ease; }
.img-swap-enter-from { opacity: 0; transform: scale(0.92); }
.img-swap-leave-to { opacity: 0; transform: scale(1.04); }

/* ===== 반응형: 1200px ===== */
@media (max-width: 1200px) {
  .unit-section { padding: 0 48px; gap: 60px; }
  .circle-frame { width: 460px; height: 460px; padding: 36px 36px 28px; }
  .main-title { font-size: 40px; }
  .intro-title { font-size: 80px; }
  .ct-name { font-size: 30px; }
  .script-title { font-size: 48px; }
}

/* ===== 반응형: 태블릿 (1024px) ===== */
@media (max-width: 1024px) {
  .unit-section {
    flex-direction: column;
    justify-content: center;
    padding: 0 40px;
    gap: 32px;
  }

  .left-area {
    max-width: 100%;
    text-align: center;
  }

  .type-tabs {
    justify-content: center;
    flex-wrap: wrap;
  }

  .type-tab {
    min-width: 60px;
    font-size: 16px;
    padding: 10px 4px;
  }

  .circle-frame {
    width: 380px;
    height: 380px;
    padding: 32px 32px 24px;
  }

  .right-area {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .main-title {
    font-size: 36px;
    letter-spacing: 4px;
    margin-bottom: 20px;
  }

  .script-title {
    font-size: 42px;
  }

  .ct-name {
    font-size: 28px;
  }

  .sub-desc {
    font-size: 15px;
    margin-bottom: 28px;
  }

  .intro-word {
    letter-spacing: 24px;
  }

  .intro-title.show .intro-word {
    letter-spacing: 10px;
  }

  .view-btn {
    right: -24px;
    width: 64px;
    height: 64px;
  }

  .view-spin {
    width: 120px;
    height: 120px;
  }

  .nav-area {
    justify-content: center;
    padding-right: 0;
  }

  .bottom-btns {
    left: 50% !important;
    transform: translateX(-50%);
    justify-content: center;
  }

  .bottom-btns.phase2-show {
    transform: translateX(-50%) translateY(0);
  }

  .bottom-btn {
    padding: 14px 28px;
    font-size: 12px;
  }
}

/* ===== 반응형: 모바일 (768px) ===== */
@media (max-width: 768px) {
  .unit-section {
    flex-direction: column;
    justify-content: center;
    padding: 0 20px;
    gap: 20px;
    height: 100vh;
    min-height: 600px;
  }

  /* 배경 */
  .bg-overlay {
    background: rgba(0, 0, 0, 0.75);
  }

  /* 인트로 타이틀 */
  .intro-word {
    font-size: clamp(36px, 8vw, 56px);
    letter-spacing: 16px;
  }

  .intro-word.is-space {
    width: 16px;
  }

  .intro-title.show .intro-word {
    letter-spacing: 6px;
  }

  /* 좌측 영역 */
  .left-area {
    max-width: 100%;
    text-align: center;
  }

  .script-title {
    font-size: 32px;
    margin-bottom: -4px;
    color: rgba(255, 255, 255, 0.7);
  }

  .main-title {
    font-size: 28px;
    letter-spacing: 3px;
    margin-bottom: 14px;
  }

  .sub-desc {
    font-size: 16px;
    margin-bottom: 20px;
    color: rgba(255, 255, 255, 0.85);
  }

  /* 타입 탭 - 터치 친화적 */
  .type-tabs {
    justify-content: center;
    gap: 4px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .type-tabs::-webkit-scrollbar {
    display: none;
  }

  .type-tab {
    min-width: 56px;
    min-height: 44px;
    padding: 10px 8px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.65);
  }

  .type-tab.is-active {
    color: #fff;
  }

  /* 원형 프레임 */
  .right-area {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .circle-frame {
    width: 260px;
    height: 260px;
    padding: 20px 20px 16px;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
  }

  .ct-name {
    font-size: 22px;
  }

  .circle-header {
    margin-bottom: 6px;
  }

  .plan-img {
    max-width: 95%;
  }

  /* VIEW 버튼 - 터치 친화적 */
  .view-btn {
    right: -20px;
    width: 56px;
    height: 56px;
  }

  .view-spin {
    width: 100px;
    height: 100px;
  }

  .view-spin text {
    font-size: 12px;
    letter-spacing: 3px;
  }

  .view-arrow {
    width: 20px;
    height: 20px;
  }

  /* 네비게이션 - 터치 친화적 */
  .nav-area {
    justify-content: center;
    padding-right: 0;
    margin-top: 16px;
    gap: 16px;
  }

  .nav-btn {
    width: 44px;
    height: 44px;
    color: rgba(255, 255, 255, 0.7);
    border-color: rgba(255, 255, 255, 0.35);
  }

  .nav-count strong {
    font-size: 20px;
  }

  .nav-count {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.5);
  }

  /* 하단 버튼 */
  .bottom-btns {
    left: 50% !important;
    transform: translateX(-50%);
    justify-content: center;
    gap: 12px;
    width: calc(100% - 40px);
  }

  .bottom-btns.phase2-show {
    transform: translateX(-50%) translateY(0);
  }

  .bottom-btn {
    padding: 14px 16px;
    font-size: 14px;
    flex: 1;
    min-height: 44px;
    white-space: nowrap;
  }
}

/* ===== 반응형: 소형 모바일 (480px) ===== */
@media (max-width: 480px) {
  .unit-section {
    padding: 0 16px;
    gap: 16px;
  }

  .script-title {
    font-size: 26px;
  }

  .main-title {
    font-size: 24px;
    letter-spacing: 2px;
    margin-bottom: 10px;
  }

  .sub-desc {
    font-size: 15px;
    margin-bottom: 16px;
  }

  .type-tabs {
    gap: 2px;
    margin-bottom: 16px;
  }

  .type-tab {
    min-width: 48px;
    font-size: 13px;
    padding: 10px 6px;
  }

  .circle-frame {
    width: 220px;
    height: 220px;
    padding: 16px 16px 12px;
  }

  .ct-name {
    font-size: 18px;
  }

  .view-btn {
    right: -16px;
    width: 48px;
    height: 48px;
  }

  .view-spin {
    width: 86px;
    height: 86px;
  }

  .view-spin text {
    font-size: 10px;
    letter-spacing: 2px;
  }

  .intro-word {
    font-size: clamp(28px, 7vw, 40px);
    letter-spacing: 10px;
  }

  .intro-title.show .intro-word {
    letter-spacing: 4px;
  }

  .bottom-btns {
    gap: 8px;
  }

  .bottom-btn {
    padding: 12px 10px;
    font-size: 13px;
  }

  .nav-area {
    margin-top: 12px;
    gap: 12px;
  }
}
</style>
